import update from "immutability-helper";
import * as Action_Constants from "../actions/shipping_fee_actions";
import { DataLoadingState } from "../../constants";

const initialState = {
  state: DataLoadingState.Uninitialized,
  data: [],
};

export function ShippingFeeReducer(state = initialState, action) {
  switch (action.type) {
    case Action_Constants.GET_SHIPPINGFEES: {
      return state.data;
    }
    case Action_Constants.SET_SHIPPINGFEES: {
      return update(state, { data: { $set: action.shippingFees } });
    }
    case Action_Constants.GET_SHIPPINGFEE_BY_LOCATION: {
      for (var i = 0; i < state.data.length; i++) {
        if (state.data[i].location === action.location) {
          return state.data[i];
        }
      }
      return null;
    }
    case Action_Constants.FETCH_SHIPPINGFEES_COMPLETED: {
      const { status, data } = action.payload;
      if (status === "Ok") {
        return update(state, {
          state: { $set: DataLoadingState.Loaded },
          data: { $set: data },
        });
      } else {
        return state;
      }
    }
    default:
      return state;
  }
}
